import { css } from 'styled-components';

export const tagColors = {
  text: {
    primary: 'var(--colour-component-tags-text-primary)',
    secondary: 'var(--colour-component-tags-text-secondary)',
  },
  bg: {
    primary: 'var(--colour-component-tags-background-primary)',
    secondary: 'var(--colour-component-tags-background-secondary)',
  },
};

export const tagColorVariables = css`
  --colour-component-tags-text-primary: var(--colour-brand-midnight);
  --colour-component-tags-text-secondary: var(--colour-role-text-invert);
  --colour-component-tags-background-primary: var(--colour-brand-vivid-blue);
  --colour-component-tags-background-secondary: var(--colour-role-bg-feature-1);
`;
